/** @jsxImportSource @emotion/react */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CheckboxStyled } from '@nike/nike-design-system-components';

import { SELECT_ALL_ORDERS } from './actions';
import { orderDetailsReportSelectors } from './reducer';

import { TranslatedCopy } from '../../intl/TranslatedCopy';

const OrdersTableHeaderRow = () => {
  const dispatch = useDispatch();

  const allOrdersSelected = useSelector(orderDetailsReportSelectors.allOrdersSelected);

  return (
    <tr>
      <th css={{ width: '68px' }}>
        <CheckboxStyled
          id='selectAllOrders'
          checked={allOrdersSelected}
          onChange={e => dispatch({ type: SELECT_ALL_ORDERS, payload: { checked: e.target.checked } })}
        />
      </th>
      <th>
        <TranslatedCopy id='global.orderNumber' />
      </th>
      <th>
        <TranslatedCopy id='global.department' />
      </th>
      <th>
        <TranslatedCopy id='global.orderType' />
      </th>
      <th>
        <TranslatedCopy id='orderstatus.poNumber' />
      </th>
      <th>
        <TranslatedCopy id='global.crd' />
      </th>
      <th>
        <TranslatedCopy id='orderstatus.orderStatus' />
      </th>
    </tr>
  );
};

export default OrdersTableHeaderRow;
